import * as React from 'react';
import { SVGProps } from 'react';

const IconResizeSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 12.607 12.607 2l1.414 1.414L3.414 14.021 2 12.607zm4.242 0 6.364-6.364 1.415 1.414-6.364 6.364-1.415-1.414zm4.243 0 2.121-2.122 1.415 1.415-2.122 2.12-1.414-1.413z" />
  </svg>
);
export default IconResizeSizeS;
